import api from "@/lib/api";
import { toast } from "sonner";
import { apiErr } from "@/lib/format";

// Descarga un archivo autenticado (Excel/PDF) desde la API.
export async function downloadFile(url, filename, params = {}) {
  try {
    const res = await api.get(url, { params, responseType: "blob" });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 2000);
  } catch (e) {
    toast.error(apiErr(e) || "No se pudo descargar el archivo");
  }
}

// Abre un PDF autenticado en una pestaña nueva.
export async function openPdf(url) {
  const w = window.open("", "_blank");
  try {
    const res = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    if (w) w.location.href = href; else window.open(href, "_blank");
  } catch (e) {
    if (w) w.close();
    toast.error(apiErr(e) || "No se pudo abrir el PDF");
  }
}
